const baseUrl = "/api/env_collect_activated_themes"

const EnvCollectActivatedThemeEntity = (backClient) => ({
  activate: async (name) => await backClient.post(baseUrl, { name }),
  deactivate: async (name) => await backClient.delete(baseUrl + `/${name}`),
})
export default EnvCollectActivatedThemeEntity
